(function () {
  'use strict';

  angular.module('app').component('hotelContentDetail', hotelContentDetail());

  function hotelContentDetail() {
    return {
      bindings: {
        item: '=',
        hotelId: '<',
        onHotelContentSaved: '&',
        onHotelContentCanceled: '&',
        websiteId: '<',
        defaultLanguage: '<',
        additionalLanguages: '<',
      },
      controller: HotelContentDetailComponent,
      controllerAs: 'vm',
      templateUrl:
        './app/ajs/hotel-contents/hotel-content-detail/hotel-content-detail.component.html',
    };
  }

  HotelContentDetailComponent.$inject = [
    'UtilService',
    'SessionService',
    'HotelContentService',
    'HotelService',
    'TagService',

    // Angular downgraded service
    'ng2Router',
  ];

  function HotelContentDetailComponent(
    UtilService,
    SessionService,
    HotelContentService,
    HotelService,
    TagService,

    // Angular downgraded service
    ng2Router
  ) {
    var vm = this;

    vm.UtilService = new UtilService(vm);
    var cropedImage = { file: null };

    // Methods
    vm.tagTransform = tagTransform;
    vm.checkTagOptions = checkTagOptions;

    vm.selectParentHotel = selectParentHotel;
    vm.updateSeoTitle = updateSeoTitle;
    vm.setSeoTitle = setSeoTitle;
    vm.updateSeoDescription = updateSeoDescription;
    vm.setSeoDescription = setSeoDescription;

    //vm.editHotelContent = editHotelContent;
    vm.cancelEdit = cancelEdit;
    vm.saveHotelContent = saveHotelContent;
    vm.cancel = cancel;
    vm.openHotelContentTranslation = openHotelContentTranslation;
    vm.openLogo = openLogo;
    // vm.isUrlValid = isUrlValid;

    vm.$onInit = function () {
      if (vm.item.id) {
        // Edit
        vm.editMode = true;

        vm.flashMessage = vm.UtilService._displayFlashMessage();

        vm.urlEmbedVideo = vm.UtilService.embedYouTubeVideo(vm.item.url_video);

        vm.itemName = vm.item.name;
        vm.labelAddLogo = vm.item.logo.url ? 'CHANGE_PHOTO' : 'ADD_PHOTO';
        vm.originalItem = angular.copy(vm.item);
      } else {
        // New
        if (vm.hotelId) {
          vm.item.hotel_id = vm.hotelId; // optional from modal
        }

        vm.item.website_id = vm.websiteId;
        vm.isUrlRequired = false;
        vm.item.url = '';

        vm.item.published = false;

        vm.labelAddLogo = 'ADD_PHOTO';
      }

      var companyWebsites = SessionService.getSelectedAccountCompany().websites;

      vm.websiteName = vm.UtilService.findItemInArray(companyWebsites, 'id', vm.websiteId).name;
      vm.tabs = vm.UtilService.websiteTabs(vm.websiteId);

      // Initializers
      getHotelsContents();
      getTags(vm.defaultLanguage);
    };

    function cancelEdit() {
      vm.cancel();
    }

    function getHotels(hotelIds) {
      HotelService.getHotels({ get: 'selector', skip_check_role: true }).then(function (data) {
        vm.hotels = [];

        data.items.forEach(function (hotel) {
          for (var i = 0; i < hotelIds.length; i++) {
            var hotelId = hotelIds[i];
            if (hotel.id === hotelId) {
              if (vm.item.hotel_id === hotelId) {
                hotel.current = true;
              } else {
                hotel.inUse = true;
              }

              break;
            }
          }

          vm.hotels.push(hotel);
        });
      });
    }

    function getHotelsContents() {
      var filterCriteria = {
        get: 'active',
        skip_check_role: true,
      };

      HotelContentService.getHotelsContents(vm.item.website_id, filterCriteria).then(function (
        data
      ) {
        var hotelIds = [];

        data.items.forEach(function (content) {
          hotelIds.push(content.hotel_id);
        });

        getHotels(hotelIds);
      });
    }

    function selectParentHotel(hotel) {
      if (!vm.item.id) {
        // Create mode
        vm.item.name = hotel.name;
        updateSeoTitle();
      }
    }

    // ----- SEO ----- //
    function updateSeoTitle() {
      if (!vm.item.seo_title_filled) {
        vm.item.seo_title = vm.item.name;
      }
    }

    function setSeoTitle() {
      vm.item.seo_title_filled = vm.item.seo_title ? true : false;
    }

    function updateSeoDescription() {
      if (!vm.item.seo_description_filled) {
        vm.item.seo_description = vm.item.description.replace(/<\/?[^>]+(>|$)/g, ''); // text only
      }
    }

    function setSeoDescription() {
      vm.item.seo_description_filled = vm.item.seo_description ? true : false;
    }

    function openLogo() {
      let logoSaved = (cropedImageObj) => {
        cropedImage = cropedImageObj;

        if (vm.editMode) {
          HotelContentService.updateLogo(vm.item, cropedImage);
        } else {
          var img = document.getElementById('logo-image-preview'); // <HTMLInputElement>
          img.src = URL.createObjectURL(cropedImage.file);
        }
      };

      HotelContentService.openLogo(vm.item, logoSaved);
    }

    // ----- TAGS ----- //

    function getTags(lang) {
      TagService.getTags({ skip_check_role: true, by_lang: lang }).then(function (data) {
        vm.tags = data.items;
      });
    }

    function tagTransform(name) {
      return TagService.tagTransform(name, vm.defaultLanguage);
    }

    function checkTagOptions(tag) {
      vm.tagOptions = TagService.checkTagOptions(tag, vm.tags);
    }

    // Create / udpate hotel content
    function saveHotelContent(isFormValid) {
      vm.formErrors = false;

      if (!isFormValid || vm.item.url === '') {
        vm.isUrlRequired = true;
        vm.serverErrors = [];
        vm.formErrors = true;

        vm.UtilService.scrollToTop();

        return;
      }

      var successCallback = function () {
        vm.sendingForm = true;
        HotelContentService.saveHotelContent(vm.item, vm.defaultLanguage, cropedImage).then(
          function (response) {
            var response = response.data;

            vm.urlEmbedVideo = vm.UtilService.embedYouTubeVideo(response.url_video);

            if (!vm.editMode) {
              // Create
              vm.onHotelContentSaved({ item: response });
            } else {
              // Edit
              vm.flashMessage = vm.UtilService._clearFlashMessage();

              vm.itemName = response.name;
              vm.originalItem = angular.copy(vm.item);
            }

            vm.sendingForm = false;

            vm.UtilService.scrollToTop();
          },
          function (response) {
            vm.serverErrors = vm.UtilService._showItemServerErrors(response.data.errors);

            if (response.data.error) {
              vm.serverErrors.publish = response.data.error;
            }

            vm.formErrors = true;
            vm.UtilService.scrollToTop();

            vm.sendingForm = false;
          }
        );
      };

      const callback = (response) => {
        if (response === 'edit') {
          vm.UtilService.scrollToTop();

          return;
        }

        if (response === 'generate') {
          vm.item.url = UtilService.prototype.generateURL(vm.item);
        }

        successCallback();
      };

      if (vm.item.id && vm.item.name !== vm.originalItem.name) {
        vm.UtilService.openProductsChangeUrlModal(callback);
      } else {
        successCallback();
      }
    }

    function cancel() {
      vm.onHotelContentCanceled({ item: vm.item });
    }

    function openHotelContentTranslation() {
      HotelContentService.openHotelContentTranslation(
        vm.item.id,
        vm.websiteName,
        vm.additionalLanguages
      );
    }

    // function isUrlValid() {
    //   if (vm.item.url === '') vm.isUrlRequired = true;
    //   return;
    // }

    vm.goToWebsiteDetail = (websiteId) => {
      ng2Router.navigate(['/ng/websites', websiteId]);
    };
  }
})();
